export enum UserMFAMethod {
  None = 'None',
  TOTP = 'TOTP',
  SMS = 'SMS',
}
